<template>
	<ContextMenuPlanning ref="menu" :model="mapItems" :baseZIndex="999" />
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import ContextMenu from 'primevue/contextmenu';
import { OPTION_CONTEXT_MENU } from '@/shared/constants';

export default {
	name: 'ContextMenu',
	components: { ContextMenuPlanning: ContextMenu },
	mixins: [languageMessages, isSingleProjectMixin, globalMixin],
	props: {},
	data: () => {
		return {
			optionContextMenu: null,
			contextMenuItemsSingle: [],
			contextMenuItemsMulti: []
		};
	},
	watch: {
		optionContextMenu: {
			handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		},
		mapItems: {
			async handler(newVal) {
				if (newVal.length !== 0) {
					const res = await new Promise((resolve, _) => {
						resolve(newVal);
					});
					await Promise.all(res).then((response) => {
						let menuX = 0;
						let menuY = 0;
						const { offsetTop: offsetTopAppFooter } = document.getElementsByClassName('app-footer')[0];
						const { tableRect, event: eventTable, widthCell, isFixedAppBar } = this.optionContextMenu;
						const { width: widthTable, height: heightTable } = tableRect;
						const {
							width: menuWidth,
							height: menuHeight,
							top: topAfterShow,
							bottom: bottomAfterShow
						} = this.$refs['menu'].$el.getBoundingClientRect();
						const clickX = eventTable.clientX;
						const clickY = eventTable.clientY;
						const sideBarShow = document.getElementsByClassName('sidebar-sm-show')[0];
						const { width: sideBarWidthActif } = document.getElementsByClassName('sidebar')[0].getBoundingClientRect();
						if (clickX + menuWidth > widthTable) {
							const left = widthTable - menuWidth - 100;
							menuX = left;
						} else {
							if (sideBarShow) {
								const left = clickX - menuWidth;
								menuX = left;
							} else {
								const left = clickX + sideBarWidthActif - menuWidth;
								menuX = left;
							}
						}
						if (clickY + menuHeight > offsetTopAppFooter) {
							const stayOfContextMenuMasqued = bottomAfterShow + menuHeight - offsetTopAppFooter - 100;
							menuY = clickY - 120 - stayOfContextMenuMasqued;
						} else {
							const isDiff = topAfterShow - clickY;
							menuY = clickY - isDiff + 10;
						}
						this.$refs['menu'].$el.style.setProperty('left', `${menuX + 1}px`, 'important');
						this.$refs['menu'].$el.style.setProperty('top', `${menuY + 1}px`, 'important');
						return response;
					});
				}
				return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		mapItems() {
			if (this.optionContextMenu) {
				const { showMenu, showMenuMultiple } = this.optionContextMenu;
				if (showMenu) return this.setOptionSingle();
				if (showMenuMultiple) return this.setOptionMulti();
				return [];
			}
			return [];
		}
	},
	methods: {
		setOptionSingle() {
			const { onMenuItemClick, hideContextMenuStopPropagation, isShowActionByStatus, isNotValitedItem, isValid, isReject, isUndoReject } =
				this.optionContextMenu;
			const { SEND_FOR_VALIDATION, UPDATE, UNDO_REJECT, DELETE, REJECT, SEE_INFO, VALIDATE } = OPTION_CONTEXT_MENU;
			let option = [
				{
					label: this.FormMSG(10, 'See info'),
					icon: 'pi pi-fw pi-eye custom-icon-eye',
					visible: true,
					command: () => onMenuItemClick(SEE_INFO)
				},
				{
					label: this.FormMSG(3, 'Send For Validation'),
					icon: 'pi pi-fw pi-send custom-icon-send',
					visible: isNotValitedItem,
					command: () => onMenuItemClick(SEND_FOR_VALIDATION)
				},
				{
					label: this.FormMSG(7, 'Update'),
					icon: 'pi pi-fw pi-pencil custom-icon-pencil',
					visible: isShowActionByStatus,
					command: () => onMenuItemClick(UPDATE)
				},
				{
					label: this.FormMSG(4, 'Validate'),
					icon: 'pi pi-fw pi-check-square custom-icon-check-square',
					visible: isValid,
					command: () => onMenuItemClick(VALIDATE)
				},
				{
					label: this.FormMSG(8, 'Delete'),
					icon: 'pi pi-fw pi-trash custom-icon-trash',
					visible: isShowActionByStatus,
					command: () => onMenuItemClick(DELETE)
				},
				{
					label: this.FormMSG(5, 'Reject'),
					icon: 'pi pi-fw pi-times custom-icon-x',
					visible: isReject,
					command: () => onMenuItemClick(REJECT)
				},
				{
					label: this.FormMSG(6, 'Undo reject'),
					icon: 'pi pi-fw pi-undo custom-icon-undo',
					visible: isUndoReject,
					command: () => onMenuItemClick(UNDO_REJECT)
				},
				{
					label: this.FormMSG(11, 'Cancel'),
					icon: 'pi pi-fw pi-power-off custom-icon-power-off',
					command: () => hideContextMenuStopPropagation()
				}
			];
			return option;
		},
		setOptionMulti() {
			const { onMenuItemClick, hideContextMenuStopPropagation, isShowActionByStatus, isNotValitedItem, isValid, isReject, isUndoReject } =
				this.optionContextMenu;
			const { SEND_FOR_VALIDATION, UNDO_REJECT, DELETE, VALIDATE, REJECT, SEE_INFO_MULTIPLE } = OPTION_CONTEXT_MENU;
			let option = [
				{
					label: this.FormMSG(3, 'Send For Validation'),
					icon: 'pi pi-fw pi-send custom-icon-send',
					visible: isNotValitedItem,
					command: () => onMenuItemClick(SEND_FOR_VALIDATION)
				},
				{
					label: this.FormMSG(9, 'See more'),
					icon: 'pi pi-fw pi-eye custom-icon-eye',
					visible: true,
					command: () => onMenuItemClick(SEE_INFO_MULTIPLE)
				},
				{
					label: this.FormMSG(4, 'Validate') + '(s)',
					icon: 'pi pi-fw pi-check-square custom-icon-check-square',
					visible: isValid,
					command: () => onMenuItemClick(VALIDATE)
				},
				{
					label: this.FormMSG(8, 'Delete'),
					icon: 'pi pi-fw pi-trash custom-icon-trash',
					visible: isShowActionByStatus,
					command: () => onMenuItemClick(DELETE)
				},
				{
					label: this.FormMSG(5, 'Reject') + '(s)',
					icon: 'pi pi-fw pi-times custom-icon-x',
					visible: isReject,
					command: () => onMenuItemClick(REJECT)
				},
				{
					label: this.FormMSG(6, 'Undo reject') + '(s)',
					icon: 'pi pi-fw pi-undo custom-icon-undo',
					visible: isUndoReject,
					command: () => onMenuItemClick(UNDO_REJECT)
				},
				{
					label: this.FormMSG(2, 'Cancel'),
					icon: 'pi pi-fw pi-power-off custom-icon-power-off',
					command: () => hideContextMenuStopPropagation()
				}
			];
			return option;
		}
	}
};
</script>
<style>
.custom-icon-check-circle,
.custom-icon-eye¨,
.custom-icon-copy,
.custom-icon-clone,
.custom-icon-clear-copy,
.custom-icon-users {
	color: #06263e !important;
}
.custom-icon-pencil,
.custom-icon-check-square,
.custom-icon-power-off,
.custom-icon-undo,
.custom-icon-send {
	color: #225cbd !important;
}
.custom-icon-trash,
.custom-icon-x,
.custom-icon-signature {
	color: #ea4e2c !important;
}
.custom-icon-trace::before {
	color: #ffd700;
}
.p-contextmenu {
	width: auto;
	min-width: 200px;
}
</style>
